import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getJobAsync } from "./jobAPI";

const sliceName = "job";
const initialState = {
    jobs: {},
    isLoading: false,
    isError: false,
    errorMessage: '',
    editing: {}
};

export const fetchJob = createAsyncThunk(`${sliceName}/fetchJob`, getJobAsync);

const jobSlice = createSlice({
    name: sliceName,
    initialState,
    reducers: {
        activateEdit: (state, action) => {
            state.editing = action.payload;
        },
        clearEdit: (state) => {
            state.editing = {};
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchJob.pending, (state) => {
                state.isLoading = true;
                state.isError = false;
            })
            .addCase(fetchJob.fulfilled, (state, action) => {
                state.jobs = action.payload;
                state.isLoading = false;
                state.isError = false;
                state.errorMessage = '';
                state.editing = action.payload;
            })
            .addCase(fetchJob.rejected, (state, action) => {
                state.isError = true;
                state.errorMessage = action.error?.message;
                state.isLoading = false;
                state.jobs = {};
            });
    }
});

export default jobSlice.reducer;
export const { activateEdit, clearEdit } = jobSlice.actions;